// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.array.from-async",
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.array-buffer.detached",
  "esnext.array-buffer.transfer",
  "esnext.array-buffer.transfer-to-fixed-length",
  "esnext.json.is-raw-json",
  "esnext.json.parse",
  "esnext.json.raw-json",
  "esnext.set.difference.v2",
  "esnext.set.intersection.v2",
  "esnext.set.is-disjoint-from.v2",
  "esnext.set.is-subset-of.v2",
  "esnext.set.is-superset-of.v2",
  "esnext.set.symmetric-difference.v2",
  "esnext.set.union.v2",
]);
